import { darken } from 'polished';

import { SUPPORTED_PROPERTIES } from '@savgroup-front-common/types';

export default {
  [SUPPORTED_PROPERTIES.COLOR]: {
    fallback: `components.defaultButtons.${SUPPORTED_PROPERTIES.COLOR}`,
  },
  [SUPPORTED_PROPERTIES.BACKGROUND_COLOR]: {
    fallback: 'colors.alert',
  },
  [SUPPORTED_PROPERTIES.ON_HOVER_BACKGROUND_COLOR]: {
    value: darken(0.075, '#F07300'),
  },
  [SUPPORTED_PROPERTIES.DISABLED_COLOR]: {
    fallback: `components.defaultButtons.${SUPPORTED_PROPERTIES.DISABLED_COLOR}`,
  },
  [SUPPORTED_PROPERTIES.DISABLED_BACKGROUND_COLOR]: {
    fallback: `components.defaultButtons.${SUPPORTED_PROPERTIES.DISABLED_BACKGROUND_COLOR}`,
  },
};
